module.exports = __webpack_public_path__ + "img/maintenance.18809dca.svg";